import { z } from "zod";

const ErrorsResponseSchema = z.object({
    name: z.array(z.string()),
    description: z.array(z.string()),
    occ_adults: z.array(z.string()),
    occ_children: z.array(z.string()),
    total_rooms: z.array(z.string()),
    room_number: z.array(z.string()),
});

export const ValidationErrorResponseCreateRoomType = z.object({
    code: z.number(),
    message: z.string(),
    errors: ErrorsResponseSchema,
    success: z.boolean(),
});

export type ValidationErrorCreateRoomType = z.infer<typeof ValidationErrorResponseCreateRoomType>;